// extracted by mini-css-extract-plugin
export default {"list":"Modal_list__jjFy9","list__list-header":"Modal_list__list-header__spQTP","list__item":"Modal_list__item__aK+tQ","overlay":"Modal_overlay__teYTL"};